import { graphql, HttpResponse } from 'msw';
import {
  FanReactionType,
  SuperMessageAreaSize,
  TextAlign,
  TextVerticalAlign,
  type GetPaymentRelatedSuperMessageQuery,
} from '@/__generated__/graphql';

export const getPaymentRelatedSuperMessage = graphql.query<GetPaymentRelatedSuperMessageQuery>(
  'GetPaymentRelatedSuperMessage',
  ({ variables }) => {
    const { paymentOrderId } = variables;

    return HttpResponse.json({
      data: {
        __typename: 'Query',
        me: {
          __typename: 'Me',
          id: '9830f6bc-8608-4487-a131-fd9f6b640cc9',
          paymentOrder: {
            __typename: 'CreditCardPaymentOrder',
            id: paymentOrderId,
            relatedItem: {
              __typename: 'PaymentRelatedSuperMessage',
              thanks_message: '応援ありがとうございます！',
              mySuperMessageBadge: {
                __typename: 'MySuperMessageBadge',
                id: '5ac7d46f-36a0-4d79-adb4-70e7b7ba6c92',
                name: 'テスト',
                artist: {
                  __typename: 'Artist',
                  id: '24aa1891-704e-424d-a838-9866298883e4',
                  color: '#E5136C',
                  slug: '1',
                  name: 'テスト用アーティスト',
                  nameEn: 'Test Artist',
                },
                image: {
                  __typename: 'Image',
                  id: 'SuperMessageBadgeImage/5ac7d46f-36a0-4d79-adb4-70e7b7ba6c92',
                  url: 'https://storage.googleapis.com/dev-klew-main-storage/artists/24aa1891-704e-424d-a838-9866298883e4/badges/super-messages/daa76ebd-141e-431b-92ff-63c4234d3019',
                },
                badgeAsset: {
                  __typename: 'SuperMessageBadgeAsset',
                  id: '7952de7a-daef-44af-becf-09f8bf1c7d45',
                },
              },
              post: {
                __typename: 'FanPost',
                ulid: `fan-post-${Date.now()}`,
                body: '最高のパフォーマンスでした！また見に行きます！',
                channelID: 'channel-001',
                isSpoiler: false,
                isMasked: false,
                createdAt: '2025-11-04T12:00:00Z',
                updatedAt: '2025-11-04T12:00:00Z',
                fan: {
                  __typename: 'Fan',
                  id: 'fan-001',
                  name: 'ファン太郎',
                  iconImage: null,
                },
                reactions: {
                  __typename: 'FanPostReactions',
                  reactionCounts: [
                    { __typename: 'FanReactionCount', type: FanReactionType.Like, count: 5 },
                  ],
                  artistReactions: [],
                  myReactions: [
                    {
                      __typename: 'FanReaction',
                      id: 'myreaction-001',
                      type: FanReactionType.Like,
                    },
                  ],
                },
                superMessageInfo: {
                  __typename: 'SuperMessageInfo',
                  cropInfo: {
                    __typename: 'CropInfo',
                    xPx: 0,
                    yPx: 0,
                    widthPx: 300,
                    heightPx: 100,
                    rotateDeg: 0,
                    scaleX: 1,
                    scaleY: 1,
                  },
                  superMessageBadge: {
                    __typename: 'SuperMessageBadge',
                    id: 'badge-001',
                    name: 'ゴールドスター',
                    price: 5000,
                    image: {
                      __typename: 'Image',
                      id: 'SuperMessageBadgeImage/5ac7d46f-36a0-4d79-adb4-70e7b7ba6c92',
                      url: 'https://storage.googleapis.com/dev-klew-main-storage/artists/24aa1891-704e-424d-a838-9866298883e4/badges/super-messages/daa76ebd-141e-431b-92ff-63c4234d3019',
                    },
                  },
                  superMessageMaster: {
                    __typename: 'SuperMessageMaster',
                    id: 'supermsg-master-001',
                    messageAreaSize: SuperMessageAreaSize.Large,
                  },
                  textLayoutInfo: {
                    __typename: 'TextLayoutInfo',
                    textHexColor: '#FFFFFF',
                    textAlign: TextAlign.Center,
                    textVerticalAlign: TextVerticalAlign.Middle,
                    textSizePx: 24,
                  },
                },
                parentContent: {
                  __typename: 'FanPost',
                  channelID: 'channel-001',
                  ulid: 'fanpost-A',
                  body: '初めてのライブ参戦！最高でした！！',
                  isSpoiler: false,
                  isMasked: false,
                  fan: {
                    __typename: 'Fan',
                    id: 'fan-001',
                    iconImage: null,
                  },
                },
              },
            },
          },
        },
      },
    });
  },
);
